import * as actionTypes from '../actionTypes';
import uuidv4 from 'uuid/v4';

export const setGlobalLoading = loading => ({ type: actionTypes.app.SET_GLOBAL_LOADING, loading });
export const setGlobalError = error => ({ type: actionTypes.app.SET_GLOBAL_ERROR, error });
export const setBugsnagClient = client => ({ type: actionTypes.app.SET_BUGSNAG_CLIENT, client });
export const setResyncTimestamp = ({
  darsTimestamp,
  divisionTimestamp,
  divisionRelationTimestamp,
  propertyTimestamp,
  userTimestamp
}) => ({
  type: actionTypes.app.SET_RESYNC_TIMESTAMP,
  darsTimestamp,
  divisionTimestamp,
  divisionRelationTimestamp,
  propertyTimestamp,
  userTimestamp
});